import { SquaresPlusIcon } from '@heroicons/react/24/outline';
import { Fragment } from 'react';
import { useFirmContext } from '../../../../providers/FirmProvider';
import FirmAtosaIntegrationCard from './atosa/FirmAtosaIntegrationCard';
import FirmFYIIntegrationCard from './fyi/FirmFYIIntegrationCard';

type FirmIntegrationsGridProps = {
    onCardSelect: (id: string) => void;
};

function FirmIntegrationsGrid({ onCardSelect }: FirmIntegrationsGridProps): JSX.Element {
    const { integrations, allowedIntegrations } = useFirmContext();

    const availableIntegrations = ['fyi', 'atosa'];

    return (
        <div className="grid gap-y-8 grid-cols-[repeat(auto-fill,300px)] gap-4">
            {Object.keys(integrations).map((key) => {
                if (key === 'fyi' && integrations[key]) {
                    return <FirmFYIIntegrationCard onConfigure={onCardSelect} status="CONNECTED" key={key} />;
                }
                if (key === 'atosa' && integrations[key]) {
                    return <FirmAtosaIntegrationCard onConfigure={onCardSelect} status="CONNECTED" key={key} />;
                }
                return <Fragment key={key} />;
            })}

            {availableIntegrations.map((i) => {
                if (i === 'fyi' && !integrations.fyi) {
                    return <FirmFYIIntegrationCard onConfigure={onCardSelect} status="DEFAULT" key={i} />;
                }
                if (i === 'atosa' && !integrations.atosa && allowedIntegrations?.includes('atosa')) {
                    return <FirmAtosaIntegrationCard onConfigure={onCardSelect} status="DEFAULT" key={i} />;
                }
                return <Fragment key={'not-found'} />;
            })}

            {/* {fyi?.cabinet ? (
                <>
                    <section className="grid gap-y-2">
                        <p className="text-sm font-bold text-gray-700 dark:text-gray-200">Connected</p>
                        <div className="flex gap-4 flex-wrap">
                            <FirmFYIIntegrationCard onConfigure={onCardSelect} status="CONNECTED" />
                        </div>
                    </section>
                    <section className="grid gap-y-2 pb-4">
                        <p className="text-sm font-bold text-gray-700 dark:text-gray-200">Available</p>
                        <div className="flex flex-col gap-y-2 text-xs items-center">
                            <SquaresPlusIcon className="w-12 h-12 text-gray-400" />
                            <p className="font-medium text-gray-900 dark:text-gray-200">No available integrations</p>
                            <p className="text-gray-500">Looks like you’ve added all available integrations, well done!</p>
                        </div>
                    </section>
                </>
            ) : (
                <section className="grid gap-y-2">
                    <p className="text-sm font-bold text-gray-700 dark:text-gray-200">Available</p>
                    <div className="flex gap-x-4">
                        <FirmFYIIntegrationCard onConfigure={onCardSelect} status="DEFAULT" />
                    </div>
                </section>
            )} */}
        </div>
    );
}
export default FirmIntegrationsGrid;
